/**
 * Returns the possessive form of a name. Names ending in "s" take just a trailing
 * apostrophe (e.g. "James" -> "James'"), everything else takes "'s" (e.g. "John" -> "John's").
 *
 * Use this anywhere a name is shown in the possessive so the app handles s-ending names
 * consistently across the whole product.
 */
export function possessive(name: string | null | undefined): string {
  if (!name) return '';
  return /s$/i.test(name) ? `${name}'` : `${name}'s`;
}
